export default class CharacterCounter extends React.PureComponent

  constructor: (props) ->
    super(props)

    @scrollToPricing = @scrollToPricing.bind(this)

  limitExceeded: ->
    @props.charCount > @props.charLimit

  scrollToPricing: (e) ->
    e.preventDefault()
    @props.scrollToPricing('limit')

  render: ->
    if @limitExceeded()
      @renderLink()
    else
      @renderRegular()

  renderRegular: ->
    <div className="character-count">
      { @renderCount() }
    </div>

  renderLink: ->
    <a className="character-count limit-exceeded"
       onClick={@scrollToPricing}
       href="#">
      { @renderWarningIcon() }
      { @renderCount() }
    </a>

  renderWarningIcon: ->
    <i className="fas fa-triangle-exclamation" />

  renderCount: ->
    <span>
      {@props.charCount}/{@props.charLimit}
    </span>
